import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://haider-expense-tracker.herokuapp.com",
});

export default axiosInstance;
